import { observer } from "mobx-react";
import React from "react";
import { Home } from "../../../AccessControl/Models/Commands/Security/Roles";
import { AppService, Types } from "../../../App/Services/AppService";

interface IElementAccordionComponentProps {
    header: any;
    rightAlign?: any;
    content: any;
    expandInd: boolean;
}

interface IElementAccordionState {
    isActive: boolean
}

@observer
export default class ElementAccordionComponent extends React.Component<IElementAccordionComponentProps, IElementAccordionState> {

    constructor(props: IElementAccordionComponentProps) {
        super(props);
        this.state = {
            isActive: false
        }
    }

    private authorisationService = AppService.get(Types.Neo.Security.AuthorisationService);

    public render() {
        
        return (
            <div className="card-body container pr-4 pl-4 pb-1 col-lg-12 col-xl-12 col-md-12">
                <div className="card-header row" id="headingOne" onClick={() => this.setState((previousState, props) => ({ isActive: !previousState.isActive }))}>
                    <div className="col-lg-9 text-left">
                        {this.props.header}
                    </div>
                    <div className="col-lg-3 row">
                        {this.authorisationService.hasRole(Home.WAC) &&
                            <div className="col-lg-8 text-right">{this.props.rightAlign}</div>
                        }
                        {this.props.expandInd &&
                            <div className="col-lg-2">{this.state.isActive ? '-' : '+'}</div>
                        } 
                    </div>
                </div>
                {this.state.isActive && this.props.expandInd && <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                    {this.props.content}
                </div>}
            </div>

        );
    }
}